<div class="flex min-h-[80vh] items-center justify-center px-4 py-12">
  <div class="w-full max-w-[820px] text-center">
    <h1
      class="text-[40px] font-medium leading-[44px] text-[#0a0a0a] sm:text-[48px] sm:leading-[48px]">
      Du möchtest einen Schul-Account?
    </h1>
    <p
      class="mt-4 text-[16px] leading-[24px] text-[#717182] sm:text-[20px] sm:leading-[28px]">
      Wähle deine Rolle und starte durch – kostenlos und unverbindlich
    </p>

    <div class="mt-12 grid grid-cols-1 gap-6 sm:gap-8 md:grid-cols-2">
      @for (role of roles; track role.id) {
        <button
          type="button"
          class="welcome-role-card w-full text-left transition-shadow"
          (click)="select(role.id)">
          <div class="welcome-role-card__inner">
            <div
              class="welcome-role-card__icon"
              [ngClass]="role.iconClass"
              aria-hidden="true">
              <img
                [src]="role.iconSrc"
                alt=""
                class="h-8 w-8 select-none"
                draggable="false" />
            </div>

            <h2
              class="mt-8 text-[24px] font-medium leading-[32px] text-[#0a0a0a]">
              {{ role.title }}
            </h2>

            @if (role.badge) {
              <div
                class="mt-3 inline-flex h-7 self-start items-center gap-2 rounded-full bg-[#eff6ff] px-3">
                <span
                  class="inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-[#1e40af]"
                  aria-hidden="true"></span>
                <span
                  class="text-[14px] font-normal leading-none text-[#1e40af]">
                  {{ role.badge }}
                </span>
              </div>
            }

            <p
              class="mt-5 text-[16px] font-normal leading-[26px] text-[#717182]">
              {{ role.description }}
            </p>
          </div>
        </button>
      }
    </div>
  </div>
</div>
